import React from "react";
import "./styles/Service.css";

const services = [
  {
    id: "fabrication",
    title: "Fabrication and Welding",
    image: "/images/welding.jpeg",
    description: "We offer high-precision welding and fabrication services tailored to meet the structural and mechanical needs of diverse industries. From custom metal structures to complex assemblies, our skilled team ensures strength, accuracy, and superior finish in every project. We work with a wide range of materials including mild steel, stainless steel, and alloys, delivering durable and high-quality fabricated components that meet industry standards and client specifications." 
  },
  {
    id: "painting",
    title: "Painting Work",
    image: "/images/painting.jpeg",
    description: "We specialize in high-performance painting solutions that meet industrial-grade standards. Whether for heavy equipment, structural steel, or fabricated components, our paints are engineered for tough environments and consistent aesthetic appeal."
  },
  {
    id: "assembly",
    title: "Mechanical Assembly",
    image: "/images/assembly.jpeg",
    description: "Our expert technicians at Reena Industries specialize in precise mechanical assembly, ensuring every component is fitted with accuracy and reliability. We follow strict quality control protocols, from sub-assembly to full-system integration, guaranteeing performance and durability in every product we deliver."
  }
];

const otherServices = [
  { 
    id: "blasting",
    title: "Shot Blasting with Copper Slag",
    image: "/images/blasting.jpeg",
    description: "Utilizing copper slag abrasive, we achieve superior surface cleanliness and anchor profile necessary for protective coatings. Ideal for structural steel, tanks, pipelines, and fabrication jobs requiring high-performance prep."
  },
  {
    id: "Irrigation",
    title: "Erection",
    image: "/images/irrigation.jpeg",
    description: "Reena Industries provides reliable structural erection services for steel fabrication and manufacturing plants. Our skilled team ensures precise installation and alignment of steel structures, machinery, and industrial components. From frameworks and platforms to heavy equipment and pipelines, we manage every phase of the erection process with strict safety standards, engineering accuracy, and timely execution."
  },
  {
    id: "metalizing",
    title: "Metalizing Work",
    image: "/images/metalizing.jpeg",
    description: "Our metalizing services form a barrier that combats corrosion and wear on fabricated parts. With advanced application techniques, we ensure lasting surface integrity across construction, marine, and infrastructure sectors."
  }
];

const Services = () => {
  return (
    <div className="container py-5 services-page">
      <div className="text-center mb-5">
        <h2 className="section-heading">Our Services</h2>
        <div className="section-separator"></div>
      </div>
      
      <div className="row g-4">
        {services.map((service, idx) => (
          <div key={idx} id={service.id} className="col-md-4 scroll-target">
            <div className="card h-100 shadow service-card border-0">
              <div className="service-img-wrapper">
                <img src={service.image} className="card-img-top" alt={service.title} />
                <div className="service-overlay-badge">Core Service</div>
              </div>
              <div className="card-body p-4 text-center">
                <h5 className="card-title mb-3">{service.title}</h5>
                <p className="card-text text-secondary">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center my-5 pt-4">
        <h2 className="section-heading">Other Services</h2>
        <div className="section-separator"></div>
      </div>
      
      <div className="row g-4">
        {otherServices.map((service, idx) => (
          <div key={idx} id={service.id} className="col-md-4 scroll-target">
            <div className="card h-100 shadow service-card border-0">
              <div className="service-img-wrapper">
                <img src={service.image} className="card-img-top" alt={service.title} />
                <div className="service-overlay-badge accent">Specialty</div>
              </div>
              <div className="card-body p-4 text-center">
                <h5 className="card-title mb-3">{service.title}</h5>
                <p className="card-text text-secondary">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
